
export enum SortOrderIndex {
  Name = 0,
  DateAdded = 1,
  DatePurchased = 2,
  ServiceDate = 3,
  ModelYear = 4
}export const SortOrder = [
  { id: SortOrderIndex.Name, label: 'Name' },
  { id: SortOrderIndex.DateAdded, label: 'Date Added' },
  { id: SortOrderIndex.DatePurchased, label: 'Date Purchased' },
  { id: SortOrderIndex.ServiceDate, label: 'Service Date' },
  { id: SortOrderIndex.ModelYear, label: 'Model Year' },
];
export const CURRENCY_USA = 'USA';

